module.exports = __webpack_public_path__ + "static/media/pic11.7e409749.jpg";